var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#E3F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.26 34H39.07C39.557 37.388 42.478 40 45.999 40H51V41C51 43.785 52.639 46.188 54.999 47.314V53C54.999 54.105 54.104 55 52.999 55H28.384L28.413 55.191C28.758 57.436 30.573 59.166 32.831 59.403L51.821 61.402C59.934 62.256 66.999 55.896 66.999 47.739C66.999 40.151 60.848 34 53.26 34Z",
    fill: "#42A7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27H23C21.895 27 21 27.895 21 29V32H53V29C53 27.895 52.105 27 51 27Z",
    fill: "#0189ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.056 42H45.999C43.343 42 40.959 40.836 39.31 39H21V51C21 52.105 21.895 53 23 53H51C52.105 53 53 52.105 53 51V48.469C50.854 47.028 49.355 44.695 49.056 42ZM33.999 47H26.999C26.447 47 25.999 46.552 25.999 46C25.999 45.448 26.447 45 26.999 45H33.999C34.551 45 34.999 45.448 34.999 46C34.999 46.552 34.551 47 33.999 47Z",
    fill: "#0189ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitCard);
export default __webpack_public_path__ + "static/media/debit_card.225ef77b1e3e5c708e11f517695202c7.svg";
export { ForwardRef as ReactComponent };